import PropTypes from 'prop-types'

import AtomProgressBar from '@s-ui/react-atom-progress-bar'

import {Indicator} from './ratingFeatureIndicator.js'
import {INDICATOR_SIZE, LABEL_POSITION, SIZES, TYPES} from './settings.js'

export const Circle = ({
  label,
  labelPosition = LABEL_POSITION.OUTSIDE,
  maxScore,
  rating,
  showIndicator = true,
  size = SIZES.LARGE
}) => {
  const percentage = rating * 10
  const hasLabel = !!label
  const isLabelInside = labelPosition === LABEL_POSITION.INSIDE
  const isLabelOutside = labelPosition === LABEL_POSITION.OUTSIDE
  return (
    <>
      {isLabelOutside && hasLabel && (
        <span className="mt-RatingFeature-header">
          <p className="mt-RatingFeature-label">{label}</p>
        </span>
      )}
      <span className="mt-RatingFeature-progressBar">
        <AtomProgressBar
          isBorderless
          type={TYPES.CIRCLE}
          size={size}
          percentage={percentage}
          progressStrokeSize="medium"
          hideIndicator={!showIndicator}
          isAnimatedOnChange={true}
          strokeLineCap="round"
        >
          <span className="mt-RatingFeature-header--circle">
            {showIndicator && <Indicator progress={rating} size={INDICATOR_SIZE.HUGE} maxScore={maxScore} />}
            {isLabelInside && hasLabel && (
              <p className="mt-RatingFeature-label mt-RatingFeature-label--huge">{label}</p>
            )}
          </span>
        </AtomProgressBar>
      </span>
    </>
  )
}

Circle.displayName = 'RatingFeature.Circle'
Circle.propTypes = {
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  maxScore: PropTypes.number,
  rating: PropTypes.number.isRequired,
  showIndicator: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES))
}
